var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.525 13.525L26.45 1.45C25.525 0.525 24.25 0 22.925 0H5C2.25 0 0.0250006 2.25 0.0250006 5L0 45C0 47.75 2.225 50 4.975 50H35C37.75 50 40 47.75 40 45V17.075C40 15.75 39.475 14.475 38.525 13.525ZM27 32.5H22.5V40C22.5 41.375 21.375 42.5 20 42.5C18.625 42.5 17.5 41.375 17.5 40V32.5H13.025C11.9 32.5 11.35 31.15 12.15 30.375L19.15 23.4C19.65 22.925 20.425 22.925 20.925 23.4L27.9 30.375C28.65 31.15 28.1 32.5 27 32.5ZM25 17.5C23.625 17.5 22.5 16.375 22.5 15V3.75L36.25 17.5H25Z",
    fill: "#ACACF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ec946a79.svg";
export { ForwardRef as ReactComponent };